/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { usePrefixClass } from '../../hooks/useConfig.mjs';
import 'vue';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';

function useClassName() {
  var classPrefix = usePrefixClass();
  var classNames = {
    classPrefix: classPrefix.value,
    tableBaseClass: {
      table: "".concat(classPrefix.value, "-table"),
      columnResizableTable: "".concat(classPrefix.value, "-table--column-resizable"),
      overflowVisible: "".concat(classPrefix.value, "-table--overflow-visible"),
      body: "".concat(classPrefix.value, "-table__body"),
      content: "".concat(classPrefix.value, "-table__content"),
      topContent: "".concat(classPrefix.value, "-table__top-content"),
      bottomContent: "".concat(classPrefix.value, "-table__bottom-content"),
      paginationWrap: "".concat(classPrefix.value, "-table__pagination-wrap"),
      tdLastRow: "".concat(classPrefix.value, "-table__td-last-row"),
      tdFirstCol: "".concat(classPrefix.value, "-table__td-first-col"),
      thCellInner: "".concat(classPrefix.value, "-table__th-cell-inner"),
      tableRowEdit: "".concat(classPrefix.value, "-table--row-edit"),
      cellEditable: "".concat(classPrefix.value, "-table__cell--editable"),
      cellEditWrap: "".concat(classPrefix.value, "-table__cell-wrap"),
      bordered: "".concat(classPrefix.value, "-table--bordered"),
      striped: "".concat(classPrefix.value, "-table--striped"),
      hover: "".concat(classPrefix.value, "-table--hoverable"),
      loading: "".concat(classPrefix.value, "-table--loading"),
      rowspanAndColspan: "".concat(classPrefix.value, "-table--rowspan-colspan"),
      empty: "".concat(classPrefix.value, "-table__empty"),
      emptyRow: "".concat(classPrefix.value, "-table__empty-row"),
      headerFixed: "".concat(classPrefix.value, "-table--header-fixed"),
      columnFixed: "".concat(classPrefix.value, "-table--column-fixed"),
      widthOverflow: "".concat(classPrefix.value, "-table--width-overflow"),
      multipleHeader: "".concat(classPrefix.value, "-table--multiple-header"),
      footerAffixed: "".concat(classPrefix.value, "-table--footer-affixed"),
      horizontalBarAffixed: "".concat(classPrefix.value, "-table--horizontal-bar-affixed"),
      affixedHeader: "".concat(classPrefix.value, "-table--affixed-header"),
      affixedHeaderElm: "".concat(classPrefix.value, "-table__affixed-header-elm"),
      affixedFooterElm: "".concat(classPrefix.value, "-table__affixed-footer-elm"),
      affixedFooterWrap: "".concat(classPrefix.value, "-table__affixed-footer-wrap"),
      scrollbarDivider: "".concat(classPrefix.value, "-table__scroll-bar-divider"),
      fullHeight: "".concat(classPrefix.value, "-table--full-height"),
      resizeLine: "".concat(classPrefix.value, "-table__resize-line"),
      obviousScrollbar: "".concat(classPrefix.value, "-table__scrollbar--obvious"),
      affixedHeaderWrap: "".concat(classPrefix.value, "-table__affixed-header-elm-wrap")
    },
    tdAlignClasses: {
      left: "".concat(classPrefix.value, "-align-left"),
      right: "".concat(classPrefix.value, "-align-right"),
      center: "".concat(classPrefix.value, "-align-center")
    },
    tableHeaderClasses: {
      header: "".concat(classPrefix.value, "-table__header"),
      thBordered: "".concat(classPrefix.value, "-table__header-th--bordered"),
      fixed: "".concat(classPrefix.value, "-table__header--fixed"),
      multipleHeader: "".concat(classPrefix.value, "-table__header--multiple")
    },
    tableFooterClasses: {
      footer: "".concat(classPrefix.value, "-table__footer"),
      fixed: "".concat(classPrefix.value, "-table__footer--fixed")
    },
    tableAlignClasses: {
      top: "".concat(classPrefix.value, "-vertical-align-top"),
      middle: "".concat(classPrefix.value, "-vertical-align-middle"),
      bottom: "".concat(classPrefix.value, "-vertical-align-bottom")
    },
    tableRowFixedClasses: {
      top: "".concat(classPrefix.value, "-table__row--fixed-top"),
      bottom: "".concat(classPrefix.value, "-table__row--fixed-bottom"),
      firstBottom: "".concat(classPrefix.value, "-table__row--fixed-bottom-first"),
      withoutBorderBottom: "".concat(classPrefix.value, "-table__row--without-border-bottom")
    },
    tableColFixedClasses: {
      left: "".concat(classPrefix.value, "-table__cell--fixed-left"),
      right: "".concat(classPrefix.value, "-table__cell--fixed-right"),
      lastLeft: "".concat(classPrefix.value, "-table__cell--fixed-left-last"),
      firstRight: "".concat(classPrefix.value, "-table__cell--fixed-right-first"),
      leftShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-left"),
      rightShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-right")
    },
    tableLayoutClasses: {
      auto: "".concat(classPrefix.value, "-table--layout-auto"),
      fixed: "".concat(classPrefix.value, "-table--layout-fixed")
    },
    tdEllipsisClass: "".concat(classPrefix.value, "-table-td--ellipsis"),
    tableFullRowClasses: {
      base: "".concat(classPrefix.value, "-table__row--full"),
      innerFullRow: "".concat(classPrefix.value, "-table__row-full-inner"),
      innerFullElement: "".concat(classPrefix.value, "-table__row-full-element"),
      firstFullRow: "".concat(classPrefix.value, "-table__first-full-row"),
      lastFullRow: "".concat(classPrefix.value, "-table__last-full-row")
    },
    tableExpandClasses: {
      iconBox: "".concat(classPrefix.value, "-table__expand-box"),
      iconCell: "".concat(classPrefix.value, "-table__expandable-icon-cell"),
      row: "".concat(classPrefix.value, "-table__expanded-row"),
      rowInner: "".concat(classPrefix.value, "-table__expanded-row-inner"),
      expanded: "".concat(classPrefix.value, "-table__row--expanded"),
      collapsed: "".concat(classPrefix.value, "-table__row--collapsed")
    },
    tableSortClasses: {
      sortable: "".concat(classPrefix.value, "-table__cell--sortable"),
      sortColumn: "".concat(classPrefix.value, "-table__sort-column"),
      title: "".concat(classPrefix.value, "-table__cell--title"),
      trigger: "".concat(classPrefix.value, "-table__cell--sort-trigger"),
      doubleIcon: "".concat(classPrefix.value, "-table__double-icons"),
      sortIcon: "".concat(classPrefix.value, "-table__sort-icon"),
      iconDirection: {
        asc: "".concat(classPrefix.value, "-table-sort-asc"),
        desc: "".concat(classPrefix.value, "-table-sort-desc")
      },
      iconActive: "".concat(classPrefix.value, "-table__sort-icon--active"),
      iconDefault: "".concat(classPrefix.value, "-icon-sort--default")
    },
    tableSelectedClasses: {
      selected: "".concat(classPrefix.value, "-table__row--selected"),
      disabled: "".concat(classPrefix.value, "-table__row--disabled"),
      checkCell: "".concat(classPrefix.value, "-table__cell-check")
    },
    tableFilterClasses: {
      filterable: "".concat(classPrefix.value, "-table__cell--filterable"),
      popup: "".concat(classPrefix.value, "-table__filter-pop"),
      icon: "".concat(classPrefix.value, "-table__filter-icon"),
      popupContent: "".concat(classPrefix.value, "-table__filter-pop-content"),
      result: "".concat(classPrefix.value, "-table__filter-result"),
      inner: "".concat(classPrefix.value, "-table__row-filter-inner"),
      bottomButtons: "".concat(classPrefix.value, "-table__filter--bottom-buttons"),
      contentInner: "".concat(classPrefix.value, "-table__filter-pop-content-inner"),
      iconWrap: "".concat(classPrefix.value, "-table__filter-icon-wrap")
    },
    asyncLoadingClass: "".concat(classPrefix.value, "-table__async-loading"),
    isFocusClass: "".concat(classPrefix.value, "-is-focus"),
    isLoadingClass: "".concat(classPrefix.value, "-is-loading"),
    isLoadMoreClass: "".concat(classPrefix.value, "-is-load-more"),
    tableTreeClasses: {
      col: "".concat(classPrefix.value, "-table__tree-col"),
      inlineCol: "".concat(classPrefix.value, "-table__tree-col--inline"),
      icon: "".concat(classPrefix.value, "-table__tree-op-icon"),
      leafNode: "".concat(classPrefix.value, "-table__tree-leaf-node")
    },
    tableDraggableClasses: {
      rowDraggable: "".concat(classPrefix.value, "-table--row-draggable"),
      rowHandlerDraggable: "".concat(classPrefix.value, "-table--row-handler-draggable"),
      colDraggable: "".concat(classPrefix.value, "-table--col-draggable"),
      handle: "".concat(classPrefix.value, "-table__handle-draggable"),
      ghost: "".concat(classPrefix.value, "-table__ele--draggable-ghost"),
      chosen: "".concat(classPrefix.value, "-table__ele--draggable-chosen"),
      dragging: "".concat(classPrefix.value, "-table__ele--draggable-dragging")
    },
    virtualScrollClasses: {
      cursor: "".concat(classPrefix.value, "-table__virtual-scroll-cursor"),
      header: "".concat(classPrefix.value, "-table__virtual-scroll-header")
    },
    positiveRotate90: "".concat(classPrefix.value, "-positive-rotate-90"),
    negativeRotate180: "".concat(classPrefix.value, "-negative-rotate-180")
  };
  return classNames;
}

export { useClassName as default };
//# sourceMappingURL=useClassName.mjs.map
